// Mock data for THS Bauprojekte GmbH

export const companyInfo = {
  name: 'THS Bauprojekte GmbH',
  tagline: 'Ihr zuverlässiger Partner für Bau und Sanierung',
  description: 'Wir sind Ihr kompetenter Ansprechpartner für hochwertige Bau- und Sanierungsprojekte. Mit jahrelanger Erfahrung realisieren wir Ihre Bauvorhaben professionell und termingerecht.',
  address: 'Bornheimer Str. 127, 53119 Bonn',
  phone: '0176 59885691',
  email: 'info@thsbauprojekte.de',
  website: 'ths-bauprojekte.de',
  openingHours: 'Montag–Freitag, ab 07:00 Uhr'
};

export const services = [
  {
    id: 1,
    title: 'Sanierung',
    description: 'Professionelle Sanierung von Wohn- und Geschäftsräumen. Wir kümmern uns um alle Aspekte Ihrer Renovierung.',
    icon: 'Wrench',
    features: ['Komplettsanierung', 'Teilsanierung', 'Modernisierung', 'Energetische Sanierung']
  },
  {
    id: 2,
    title: 'Schlüsselfertiger Bau',
    description: 'Von der Planung bis zur Übergabe - wir realisieren Ihr Bauprojekt komplett aus einer Hand.',
    icon: 'Home',
    features: ['Neubau', 'Umbau', 'Ausbau', 'Projektmanagement']
  },
  {
    id: 3,
    title: 'Innenausbau',
    description: 'Hochwertige Innenraumgestaltung mit Liebe zum Detail und handwerklicher Präzision.',
    icon: 'PaintBucket',
    features: ['Trockenbau', 'Bodenverlegung', 'Malerarbeiten', 'Fliesenarbeiten']
  },
  {
    id: 4,
    title: 'Architektur & Planung',
    description: 'Individuelle Planung und Beratung für Ihr Bauvorhaben mit modernster Technik.',
    icon: 'Ruler',
    features: ['Bauplanung', 'Statik', 'Beratung', 'Genehmigungen']
  }
];

export const projects = [
  {
    id: 1,
    title: 'Moderne Wohnsanierung',
    category: 'Sanierung',
    description: 'Komplettsanierung einer 120m² Wohnung mit modernem Design',
    image: 'https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzY5NjQxMTA1fDA&ixlib=rb-4.1.0&q=85',
    year: '2024'
  },
  {
    id: 2,
    title: 'Neubau Einfamilienhaus',
    category: 'Schlüsselfertig',
    description: 'Schlüsselfertiger Neubau mit 180m² Wohnfläche',
    image: 'https://images.pexels.com/photos/34840277/pexels-photo-34840277.jpeg',
    year: '2024'
  },
  {
    id: 3,
    title: 'Bürogebäude Renovierung',
    category: 'Sanierung',
    description: 'Umfassende Renovierung eines Bürogebäudes',
    image: 'https://images.pexels.com/photos/33607880/pexels-photo-33607880.jpeg',
    year: '2023'
  },
  {
    id: 4,
    title: 'Dachgeschoss Ausbau',
    category: 'Innenausbau',
    description: 'Hochwertiger Ausbau eines Dachgeschosses',
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxjb25zdHJ1Y3Rpb24lMjBzaXRlfGVufDB8fHx8MTc2OTY0MTEwMHww&ixlib=rb-4.1.0&q=85',
    year: '2023'
  },
  {
    id: 5,
    title: 'Gewerbehalle Neubau',
    category: 'Schlüsselfertig',
    description: 'Neubau einer modernen Gewerbehalle',
    image: 'https://images.unsplash.com/photo-1599995903128-531fc7fb694b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBzaXRlfGVufDB8fHx8MTc2OTY0MTEwMHww&ixlib=rb-4.1.0&q=85',
    year: '2023'
  },
  {
    id: 6,
    title: 'Altbau Sanierung',
    category: 'Sanierung',
    description: 'Denkmalgerechte Sanierung eines Altbaus',
    image: 'https://images.pexels.com/photos/2138126/pexels-photo-2138126.jpeg',
    year: '2022'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Familie Schmidt',
    location: 'Wesseling',
    rating: 5,
    text: 'Hervorragende Arbeit! Die Sanierung unseres Hauses wurde professionell und termingerecht durchgeführt. Wir sind sehr zufrieden mit dem Ergebnis.',
    project: 'Haussanierung'
  },
  {
    id: 2,
    name: 'Peter Müller',
    location: 'Köln',
    rating: 5,
    text: 'Von der Planung bis zur Fertigstellung hat alles perfekt geklappt. Sehr kompetentes Team und faire Preise.',
    project: 'Neubau Einfamilienhaus'
  },
  {
    id: 3,
    name: 'Wagner GmbH',
    location: 'Bonn',
    rating: 5,
    text: 'Zuverlässiger Partner für unsere Gewerbeprojekte. Professionelle Abwicklung und hohe Qualität der Arbeiten.',
    project: 'Bürosanierung'
  }
];

export const stats = [
  { label: 'Jahre Erfahrung', value: '15+' },
  { label: 'Abgeschlossene Projekte', value: '180+' },
  { label: 'Meister im Betrieb', value: '3' },
  { label: 'Mitarbeiter & Partner', value: '25+' }
];

export const aboutText = {
  title: 'Über THS Bauprojekte GmbH',
  subtitle: 'Ihr zuverlässiger Partner für Bau und Sanierung',
  description: 'THS Bauprojekte GmbH ist Ihr kompetenter Ansprechpartner für hochwertige Bau- und Sanierungsprojekte in Bonn und Umgebung. Mit über 15 Jahren Erfahrung im Bauwesen haben wir uns auf Sanierung, schlüsselfertigen Bau und Innenausbau spezialisiert.',
  values: [
    {
      title: 'Qualität',
      description: 'Wir setzen auf höchste Qualitätsstandards bei allen unseren Projekten'
    },
    {
      title: 'Zuverlässigkeit',
      description: 'Termintreue und Verlässlichkeit sind für uns selbstverständlich'
    },
    {
      title: 'Kompetenz',
      description: 'Unser erfahrenes Team steht für fachliche Expertise und Know-how'
    },
    {
      title: 'Kundennähe',
      description: 'Wir legen großen Wert auf persönliche Betreuung und individuelle Lösungen'
    }
  ]
};

export const team = [
  {
    id: 1,
    name: 'Redon Thaqi',
    position: 'Geschäftsführer',
    experience: 'Geschäftsführung & Leitung',
    description: 'Geschäftsführer und Leitung der THS Bauprojekte GmbH',
    featured: true
  },
  {
    id: 2,
    name: 'P. Schmidt',
    position: 'Architekt & Bausachverständiger',
    experience: '50+ Jahre Erfahrung',
    description: 'Architekt und Bausachverständiger mit jahrzehntelanger Expertise',
    featured: true
  },
  {
    id: 3,
    name: 'Isret Thaqi',
    position: 'Rohbau-, Maurer- & Betonmeister',
    experience: '30 Jahre Erfahrung',
    description: 'Meisterliche Kompetenz im Bereich Rohbau, Maurerarbeiten und Betonbau',
    featured: true
  },
  {
    id: 4,
    name: 'Enis Thaqi',
    position: 'Hauptbauleiter & Projektleiter',
    experience: 'Vertretung der Geschäftsführung',
    description: 'Koordination und Leitung aller Bauprojekte mit höchster Präzision',
    featured: true
  },
  {
    id: 5,
    name: 'Hans Lohmer',
    position: 'Meister, Projektleiter & Bauleiter',
    experience: 'Meisterbetrieb',
    description: 'Erfahrener Meister und Bauleiter mit umfassender Projektkompetenz',
    featured: false
  },
  {
    id: 6,
    name: 'Arben Bytyqi',
    position: 'Malermeister & Trockenbau-Experte',
    experience: 'Meisterbetrieb',
    description: 'Spezialist für hochwertige Malerarbeiten und professionellen Trockenbau',
    featured: false
  },
  {
    id: 7,
    name: 'Edmir Bytyqi',
    position: 'Stuckateur & Vermessungstechniker',
    experience: 'Meisterbetrieb',
    description: 'Experte für Stuckarbeiten, Vermessung und professionellen Trockenbau',
    featured: false
  },
  {
    id: 8,
    name: 'Valbona Thaqi',
    position: 'Büroleitung & Administration',
    experience: 'Organisation & Verwaltung',
    description: 'Kompetente Verwaltung aller administrativen Aufgaben und Büroorganisation',
    featured: false
  }
];

export const partners = [
  { 
    name: 'Knauf', 
    logo: 'https://customer-assets.emergentagent.com/job_bauprofi-wesseling/artifacts/kaqqc83y_IMG_1006.png'
  },
  { 
    name: 'Raab Karcher', 
    logo: 'https://customer-assets.emergentagent.com/job_bauprofi-wesseling/artifacts/p6txcwlz_IMG_1007.jpeg'
  },
  { 
    name: 'Fassbender', 
    logo: 'https://customer-assets.emergentagent.com/job_bauprofi-wesseling/artifacts/mckbnke4_IMG_1008.png'
  },
  { 
    name: 'Bosch', 
    logo: 'https://customer-assets.emergentagent.com/job_bauprofi-wesseling/artifacts/ixcf07nq_IMG_1009.png'
  },
  { 
    name: 'Baumit', 
    logo: 'https://customer-assets.emergentagent.com/job_bauprofi-wesseling/artifacts/thbpd2oh_IMG_1011.webp'
  },
  { 
    name: 'Bostik', 
    logo: 'https://customer-assets.emergentagent.com/job_bauprofi-wesseling/artifacts/kq1iafy1_IMG_1013.png'
  },
  { 
    name: 'Weber', 
    logo: 'https://customer-assets.emergentagent.com/job_bauprofi-wesseling/artifacts/b52emwr0_IMG_1012.jpeg'
  },
  {
    name: 'Partner 8',
    logo: 'https://customer-assets.emergentagent.com/job_bauprofi-wesseling/artifacts/t1877sjp_IMG_1942.jpeg'
  },
  {
    name: 'Partner 9',
    logo: 'https://customer-assets.emergentagent.com/job_bauprofi-wesseling/artifacts/7yuvgbrv_IMG_1941.jpeg'
  }
];